import * as React from 'react';

type Props = {
  src?: string;
  border?: boolean;
  width?: string;
  height?: string;
  title?: string;
};

// eslint-disable-next-line react/display-name
const Frame = React.forwardRef<HTMLIFrameElement, Props>(
  ({ src, border, width = '100%', height = '400px', title }, ref) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [iframeLoaded, setIframeLoaded] = React.useState(false);

    React.useEffect(() => {
      let mounted = true;
      setTimeout(() => {
        if (mounted) {
          setIsLoaded(true);
        }
      }, 0);

      return () => {
        mounted = false;
      };
    }, []);

    return (
      <div
        className={`overflow-hidden rounded-lg mt-4 relative ${border ? 'border' : ''}`}
        style={{
          width,
          height,
        }}
      >
        {isLoaded && (
          <>
            <div className={`absolute w-full h-full ${!iframeLoaded ? 'block' : 'hidden'}`}>
              <div className="absolute inset-0 bg-muted/10 rounded-lg">
                <div className="absolute inset-0">
                  <div className="h-full w-full shimmer" />
                  <div className="absolute left-1/2 top-1/2 -translate-1/2 flex flex-col items-center gap-2">
                    <div className="modern-spinner" />
                    <div className="text-sm text-muted-foreground">Loading...</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={!iframeLoaded ? 'invisible' : 'visible'}>
              <iframe
                ref={ref}
                src={src}
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
                width={width}
                height={height}
                title="embed"
                loading="lazy"
                allowFullScreen
                className="block rounded-lg"
                onLoad={() => setIframeLoaded(true)}
              />
              {title && <span className="block text-center text-sm font-medium">{title}</span>}
            </div>
          </>
        )}
      </div>
    );
  },
);

export default Frame;
